module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading || _vm.progressBar.enabled) ? _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "uil-default-css",
    staticStyle: {
      "transform": "scale(0.7)"
    }
  }, [_c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(0deg) translate(0,-60px)",
      "transform": "rotate(0deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(30deg) translate(0,-60px)",
      "transform": "rotate(30deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(60deg) translate(0,-60px)",
      "transform": "rotate(60deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(90deg) translate(0,-60px)",
      "transform": "rotate(90deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(120deg) translate(0,-60px)",
      "transform": "rotate(120deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(150deg) translate(0,-60px)",
      "transform": "rotate(150deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(180deg) translate(0,-60px)",
      "transform": "rotate(180deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(210deg) translate(0,-60px)",
      "transform": "rotate(210deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(240deg) translate(0,-60px)",
      "transform": "rotate(240deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(270deg) translate(0,-60px)",
      "transform": "rotate(270deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(300deg) translate(0,-60px)",
      "transform": "rotate(300deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  }), _c('div', {
    staticStyle: {
      "top": "80px",
      "left": "93px",
      "width": "14px",
      "height": "40px",
      "background": "#000000",
      "-webkit-transform": "rotate(330deg) translate(0,-60px)",
      "transform": "rotate(330deg) translate(0,-60px)",
      "border-radius": "10px",
      "position": "absolute"
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.loadingText))]), _vm._v(" "), (_vm.progressBar.enabled) ? _c('div', {
    staticClass: "progress mt-10"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-striped active",
    style: ({
      width: _vm.progressBar.pourcentage + '%'
    }),
    attrs: {
      "id": "progressBar",
      "role": "progressbar",
      "aria-valuenow": _vm.progressBar.value,
      "aria-valuemin": _vm.progressBar.min,
      "aria-valuemax": _vm.progressBar.max
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "width": "50%",
      "margin": "auto",
      "color": "black"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.progressBar.txt) + "\n        ")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm.data || (_vm.data && _vm.data.session && !_vm.data.session.authenticated) || _vm.$route.name == 'login' || _vm.$route.name == 'quizzes_show') ? _c('router-view') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.data && _vm.data.session && _vm.data.session.authenticated) && _vm.$route.name != 'login' && _vm.$route.name != 'quizzes_show'),
      expression: "(data && data.session && data.session.authenticated) && $route.name != 'login' && $route.name != 'quizzes_show'"
    }],
    staticClass: "page-header-fixed page-sidebar-closed-hide-logo page-content-white"
  }, [_c('div', {
    staticClass: "page-header navbar navbar-fixed-top"
  }, [_c('div', {
    staticClass: "page-header-inner "
  }, [_c('div', {
    staticClass: "page-logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('img', {
    staticClass: "logo-default",
    attrs: {
      "src": require("./assets/logo_transferh.png"),
      "alt": "logo"
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "top-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.user.role == 'dev'),
      expression: "data.user.role == 'dev'"
    }],
    staticClass: "role_user"
  }, [_c('span', {
    staticClass: "label label-sm label-success"
  }, [_vm._v("Développeur")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown",
      "data-hover": "dropdown",
      "data-close-others": "true"
    }
  }, [_c('span', {
    staticClass: "username username-hide-on-mobile"
  }, [_vm._v(" " + _vm._s(_vm.data.user.firstname) + " " + _vm._s(_vm.data.user.lastname) + " ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-default"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" Mon compte")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.logout(true)
      }
    }
  }, [_c('i', {
    staticClass: "icon-logout"
  }), _vm._v(" Se déconnecter\n                                ")])])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-quick-sidebar-toggler",
    on: {
      "click": function($event) {
        _vm.logout(true)
      }
    }
  }, [_vm._m(2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "page-sidebar-wrapper"
  }, [_c('div', {
    staticClass: "page-sidebar navbar-collapse collapse fixed"
  }, [_c('ul', {
    staticClass: "page-sidebar-menu  page-header-fixed",
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "data-keep-expanded": "false",
      "data-auto-scroll": "true",
      "data-slide-speed": "200"
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', {
    staticClass: "nav-item start",
    class: {
      'active': _vm.$route.matched[0].name == 'quizzes', 'open': _vm.$route.matched[0].name == 'quizzes'
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "icon-note"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Questionnaires")]), _vm._v(" "), _c('span', {
    staticClass: "arrow open"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.matched[0].name == 'quizzes'),
      expression: "$route.matched[0].name == 'quizzes'"
    }],
    staticClass: "selected"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.name == 'quizzes_create', 'open': _vm.$route.name == 'quizzes_create'
    }
  }, [_c('router-link', {
    key: _vm.$route.fullPath,
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'quizzes_create'
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Créer")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.name == 'quizzes_list', 'open': _vm.$route.name == 'quizzes_list'
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'quizzes_list'
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Liste")])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.matched[0].name == 'compare', 'open': _vm.$route.matched[0].name == 'compare'
    }
  }, [_c('router-link', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "to": {
        name: 'compare'
      }
    }
  }, [_c('i', {
    staticClass: "icon-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Comparaison")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.matched[0].name == 'compare'),
      expression: "$route.matched[0].name == 'compare'"
    }],
    staticClass: "selected"
  })])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.user.role == 'dev'),
      expression: "data.user.role == 'dev'"
    }],
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.matched[0].name == 'users', 'open': _vm.$route.matched[0].name == 'users'
    }
  }, [_c('a', {
    staticClass: "nav-link nav-toggle",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "icon-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Utilisateurs")]), _vm._v(" "), _c('span', {
    staticClass: "arrow open"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.matched[0].name == 'users'),
      expression: "$route.matched[0].name == 'users'"
    }],
    staticClass: "selected"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.name == 'users_create', 'open': _vm.$route.name == 'users_create'
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'users_create'
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Créer")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'active': _vm.$route.name == 'users_list', 'open': _vm.$route.name == 'users_list'
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'users_list'
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Liste")])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "heading"
  }, [_c('h3', {}, [_vm._v("Version " + _vm._s(_vm.version))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "page-content"
  }, [(_vm.$route.name != 'quizzes_show' && _vm.$route.name != 'login') ? _c('router-view') : _vm._e()], 1)])]), _vm._v(" "), _vm._m(5)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-toggler sidebar-toggler"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "menu-toggler responsive-toggler",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle"
  }, [_c('i', {
    staticClass: "icon-logout"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "sidebar-toggler-wrapper hide"
  }, [_c('div', {
    staticClass: "sidebar-toggler"
  }, [_c('span')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "heading"
  }, [_c('h3', {
    staticClass: "uppercase"
  }, [_vm._v("Fonctionalités")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer mt-10"
  }, [_c('div', {
    staticClass: "page-footer-inner"
  }, [_vm._v(" 2017 © TransfeRH  | \n            Site réalisé par "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://lewebfrancais.fr"
    }
  }, [_vm._v("Le Web Français")])]), _vm._v(" "), _c('div', {
    staticClass: "scroll-to-top"
  }, [_c('i', {
    staticClass: "icon-arrow-up"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d320793c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 125
// module chunks = 0